import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PublicProfileClassificationComponent extends Component {
  static readonly TYPE_ID: string = '8d8203d3892e45589e06c94d88bdaf70';

  constructor(
    public readonly isFeatured: boolean,
    public readonly featuredScore: number,
  ) {
    super();
  }

  get $typeId(): string {
    return PublicProfileClassificationComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create(args: {
    isFeatured: boolean,
    featuredScore: number,
  }): PublicProfileClassificationComponent {
    return new PublicProfileClassificationComponent(
        args.isFeatured,
        args.featuredScore,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): PublicProfileClassificationComponent {
    return this.create({
      isFeatured: MapUtils.getBoolean(map, 'isFeatured'),
      featuredScore: MapUtils.getInteger(map, 'featuredScore'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      isFeatured: this.isFeatured,
      featuredScore: this.featuredScore,
    };
  }

  copyWith({
    isFeatured = this.isFeatured,
    featuredScore = this.featuredScore,
  }: {
    isFeatured?: boolean,
    featuredScore?: number,
  } = {}): this {
    return PublicProfileClassificationComponent.create({
      isFeatured,
      featuredScore,
    }) as this;
  }

  clone(): this {
    return this.copyWith();
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.isFeatured === this.isFeatured &&
        other.featuredScore === this.featuredScore;
  }
}

export class PublicProfileClassificationComponentBuilder extends DataModelBuilder<PublicProfileClassificationComponent> {
  build(context: SerializationContext, map: SerializedData): PublicProfileClassificationComponent {
    return PublicProfileClassificationComponent.fromMap(context, map);
  }
}
